import { checkAppVersion } from '@/api/appVersion'

/**
 * 版本检查服务
 * 在 APP 启动时调用，检查是否有新版本
 */
export function initVersionCheck() {
  // 只在 Capacitor 环境中检查（APP 环境）
  if (!window.Capacitor) {
    return
  }

  // 获取当前版本号和平台
  const currentVersion = parseInt(process.env.VUE_APP_VERSION_CODE || '1')
  const platform = window.Capacitor.getPlatform().toUpperCase()

  // 延迟 2 秒检查，避免影响启动速度
  setTimeout(async () => {
    try {
      const response = await checkAppVersion(platform, currentVersion)
      
      if (response.data && response.data.hasUpdate) {
        // 存储版本信息到 localStorage，供 App.vue 读取
        localStorage.setItem('version_update_info', JSON.stringify({
          hasUpdate: true,
          currentVersion,
          latestVersion: response.data.latestVersionName,
          downloadUrl: response.data.downloadUrl,
          description: response.data.updateDescription,
          forceUpdate: response.data.forceUpdate
        }))

        // 触发自定义事件通知 App.vue
        window.dispatchEvent(new CustomEvent('version-update-available'))
      }
    } catch (error) {
      console.error('版本检查失败:', error)
    }
  }, 2000)
}
